export const webReporter = url => batchPayload => {
  try {
    const body = JSON.stringify({
      messages: batchPayload
    });
    return navigator.sendBeacon(url, body);
  } catch (e) {
    console.error(e);
    return false;
  }
};
//# sourceMappingURL=reporter.js.map